import React, { useState } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Collapse } from 'react-bootstrap';
import { TbChevronDown, TbRefresh, TbX } from 'react-icons/tb';
import clsx from 'classnames';

function ComponentCard({
  title,
  titleClassName,
  isCloseable,
  isCollapsible,
  isRefreshable,
  className,
  bodyClassName,
  children,
  headerTrailing,
}) {
  const [isVisible, setIsVisible] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  if (!isVisible) return null;

  const handleToggle = () => setIsCollapsed(!isCollapsed);
  const handleClose = () => setIsVisible(false);
  const handleRefresh = () => {
    setIsRefreshing(true);
    setTimeout(() => setIsRefreshing(false), 1500);
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  function IconButton({ onClick, children }) {
    return (
      <button
        type="button"
        className="card-action-item btn btn-link p-0 border-0 d-flex justify-content-center align-items-center"
        onClick={onClick}
      >
        {children}
      </button>
    );
  }

  const renderActions = () => {
    if (!isCollapsible && !isRefreshable && !isCloseable && !headerTrailing) return null;

    return (
      <div className="card-action">
        {headerTrailing && headerTrailing}
        {isCollapsible && (
          <IconButton onClick={handleToggle}>
            <TbChevronDown style={{ rotate: isCollapsed ? '0deg' : '180deg' }} />
          </IconButton>
        )}
        {isRefreshable && (
          <IconButton onClick={handleRefresh}>
            <TbRefresh />
          </IconButton>
        )}
        {isCloseable && (
          <IconButton onClick={handleClose}>
            <TbX />
          </IconButton>
        )}
      </div>
    );
  };

  return (
    <Card className={clsx(isCollapsed && 'card-collapse', className)}>
      {isRefreshing && (
        <div className="card-overlay">
          <div className="spinner-border text-primary" />
        </div>
      )}

      {title ? (
        <CardHeader className="d-flex justify-content-between align-items-center">
          <CardTitle className={titleClassName || ''}>{title}</CardTitle>
          {renderActions()}
        </CardHeader>
      ) : (
        renderActions()
      )}

      {isCollapsible ? (
        <Collapse in={!isCollapsed}>
          <CardBody className={bodyClassName}>{children}</CardBody>
        </Collapse>
      ) : (
        <CardBody className={bodyClassName}>{children}</CardBody>
      )}
    </Card>
  );
}

export default ComponentCard;
